import { useState } from 'react'

import { DialogContent, DialogHeader, DialogTitle, Dialog } from 'src/shared/components/ui/popups/dialog'
import { ResponsivePopup } from 'src/shared/components/ui/popups/responsive-popup'
import { SupportContent } from 'src/shared/features/support/components/support-content'
import useBreakpoint from 'src/shared/hooks/use-breakpoint'
import { cn } from 'src/shared/utils/cn'

interface SupportDialogProps {
  trigger: React.ReactNode
}

export const SupportDialog = ({ trigger }: SupportDialogProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <ResponsivePopup
      open={isOpen}
      onOpenChange={setIsOpen}
      trigger={trigger}
      // mobileRoute="/support"
      title="Support request"
      className="rounded-[25px]"
    >
      <SupportContent onClose={() => setIsOpen(false)} />
    </ResponsivePopup>
  )
}

interface SupportDialogControlledProps {
  open: boolean
  setOpen: (open: boolean) => void
}

/** A support popup with open state controlled from outside the component. Has a similar UI to SupportDialog. */
export const SupportDialogControlled = ({ open, setOpen }: SupportDialogControlledProps) => {
  const { isMobile } = useBreakpoint()

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className={cn(
          'max-w-[min(90vw,510px)] rounded-[25px] p-8 sm:rounded-[25px]',
          isMobile && 'max-w-full rounded-none',
        )}
        closeIconClassName="size-6 top-6 right-6"
        fullScreen={isMobile}
      >
        <DialogHeader className="pb-2">
          <DialogTitle className="text-left text-[26px] font-semibold leading-tight tracking-[-0.16px] xs:text-center xs:text-[32px]">
            Support request
          </DialogTitle>
        </DialogHeader>
        <SupportContent onClose={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  )
}
